import { render, staticRenderFns } from "./ViewKnowledge.vue?vue&type=template&id=6b835d7a&scoped=true"
import script from "./ViewKnowledge.vue?vue&type=script&lang=js"
export * from "./ViewKnowledge.vue?vue&type=script&lang=js"
import style0 from "./ViewKnowledge.vue?vue&type=style&index=0&id=6b835d7a&prod&lang=css"
import style1 from "./ViewKnowledge.vue?vue&type=style&index=1&id=6b835d7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b835d7a",
  null
  
)

export default component.exports